import {
  breakpoints as bp,
  colors as cl,
  app as ap,
} from '@/styles/exports';

export const breakpoints = bp;
export const colors = cl;
export const appStyles = ap;

export const appName = process.env.VUE_APP_NAME;
export const appDomain = process.env.VUE_APP_DOMAIN;
export const appDescription = process.env.VUE_APP_DESCRIPTION;

export const environment = (function () {
  switch (window.location.hostname) {
    case 'localhost':
      return 'development';
    default:
      return 'production';
  }
})();

export const clientOrigin = (function () {
  if (process.env.NODE_ENV === 'production') {
    return 'https://blackjacktrainer.app';
  }

  switch (environment) {
    case 'development':
      return 'http://localhost:3000';
    default:
      return 'https://blackjacktrainer.app';
  }
})();

export const deckCounts = {
  1: 'Single deck',
  2: 'Double deck',
  4: '4 decks',
  6: '6 decks',
  8: '8 decks',
};

export const gameModeDetails = {
  default: { name: 'Default', detail: 'Standard Blackjack game.' },
  pairs: {
    name: 'Pairs',
    detail:
      'Hand always starts with a random pair. Deck is reshuffled each hand.',
  },
  uncommon: {
    name: 'Uncommon',
    detail:
      'Hand always starts with a difficult basic strategy hand (for example 9/9 vs 7). Deck is reshuffled each hand.',
  },
  deviations: {
    name: 'Deviations',
    detail:
      'Hand always starts with one of the Illustrious 18 or Fabulous 4 deviations.',
  },
};

export const supportMailTo = 'mailto:contact@mail.blackjacktrainer.app';
